import React, { useEffect, useState } from 'react';

export default function OfferExpired() {
  const [countdown, setCountdown] = useState(10);

  const fromParam = new URLSearchParams(window.location.search).get('from');

  const goBack = () => {
    if (fromParam) {
      window.location.href = fromParam;
    } else {
      window.history.go(-2);
    }
  };

  useEffect(() => {
    if (countdown <= 0) { goBack(); return; }
    const id = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(id);
  }, [countdown]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
      fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
      padding: '24px',
      textAlign: 'center',
    }}>
      {/* Icon */}
      <div style={{
        width: '80px', height: '80px', borderRadius: '50%',
        background: 'rgba(239,68,68,0.15)', border: '2px solid rgba(239,68,68,0.4)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        marginBottom: '32px', fontSize: '2rem',
      }}>
        ⏱
      </div>

      <h1 style={{
        fontSize: '2.2rem', fontWeight: 800,
        color: '#f8fafc', margin: '0 0 12px',
        letterSpacing: '-0.02em',
      }}>
        This Offer Has Expired
      </h1>

      <p style={{
        fontSize: '1.05rem', color: 'rgba(248,250,252,0.6)',
        maxWidth: '420px', lineHeight: 1.6, margin: '0 0 40px',
      }}>
        Unfortunately the window for this special offer has closed. Keep an eye out — new opportunities may be just around the corner.
      </p>

      <button
        onClick={goBack}
        style={{
          padding: '14px 36px',
          background: 'linear-gradient(135deg, #2177FF, #1EACA6)',
          color: '#fff', border: 'none', borderRadius: '9999px',
          fontSize: '1rem', fontWeight: 700, cursor: 'pointer',
          boxShadow: '0 4px 24px rgba(33,119,255,0.35)',
          transition: 'opacity 0.2s',
        }}
        onMouseEnter={e => (e.currentTarget.style.opacity = '0.85')}
        onMouseLeave={e => (e.currentTarget.style.opacity = '1')}
      >
        ← Go Back
      </button>

      <p style={{
        marginTop: '20px', fontSize: '0.8rem',
        color: 'rgba(248,250,252,0.35)',
      }}>
        Redirecting automatically in {countdown}s
      </p>
    </div>
  );
}
